import React from 'react';
import styles from '../styles/Header.module.css';
import HeaderNav from './HeaderNav';

/**
 * Header Component
 * Logo, the You·Circles·Coach nav, and the hamburger menu button.
 *
 * Props:
 * - onOpenMenu: open the hamburger menu
 * - navActive: 'you' | 'circles' | 'coach' (which slot is highlighted)
 * - onNavYou / onNavCircles / onNavCoach: slot handlers
 * - showCircles: false when the Circles feature is switched off (ENABLE_CIRCLES)
 *   — the slot leaves the nav
 * - showCoach: false when human coaching is switched off (ENABLE_COACHES)
 *   — the slot leaves the nav
 * - circlesUnread: unread activity in any circle
 * - circlesLocked: Circles gated behind Sophia Together (no plan + no invite)
 * - coachScheduled / coachJoinable: coaching-session status for the Coach slot
 */
function Header({
  onOpenMenu,
  navActive = 'you',
  onNavYou,
  onNavCircles,
  onNavCoach,
  showCircles = true,
  showCoach = true,
  circlesUnread = false,
  circlesLocked = false,
  coachScheduled = false,
  coachJoinable = false
}) {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logoContainer}>
          <h1 className={styles.logo}>Sophia</h1>
          <div className={styles.statusGroup}>
            <div className={styles.statusDot}></div>
          </div>
        </div>

        <HeaderNav
          active={navActive}
          onYou={onNavYou}
          onCircles={onNavCircles}
          onCoach={onNavCoach}
          showCircles={showCircles}
          showCoach={showCoach}
          circlesUnread={circlesUnread}
          circlesLocked={circlesLocked}
          coachScheduled={coachScheduled}
          coachJoinable={coachJoinable}
        />

        <button onClick={onOpenMenu} className={styles.menuButton} aria-label="Open menu" data-tour="hamburger-menu">
          <span className={styles.hamburgerIcon}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
    </header>
  );
}

export default Header;
